import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { InputSize, InputVariant } from "./Input.constants";
import { handleReactSlot } from "../../utils/react";

import styles from "./Input.module.scss";

const preventKeyDownForNumberTypeStrict = (e) => {
  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
};

const Input = forwardRef(({
  isPreventKeyDownForNumberTypeStrict,
  inputClassName,
  className, active, hasPlaceholderColorActive, variant, rounded, size,
  isRootDirectionColumn,
  slotBefore,
  slotAfter,
  isTextarea,
  tagRoot: TagRoot = "div",
  rootProps,
  tagInput: TagInput = "input",
  ...restProps
}, ref) => {
  return (
    <TagRoot
      {...rootProps}
      className={classnames(styles["root"], className, styles[variant], styles[size], {
        [styles["rounded"]]: rounded,
        [styles["active"]]: active,
        [styles["has-placeholder-color-active"]]: hasPlaceholderColorActive,
        [styles["read-only"]]: restProps.readOnly,
        [styles["disabled"]]: restProps.disabled,
        [styles["has-slot-before"]]: !!slotBefore,
        [styles["has-slot-after"]]: !!slotAfter,
        [styles["is-direction-column"]]: isRootDirectionColumn,
      })}
    >
      {slotBefore ? handleReactSlot(slotBefore) : null}
      <TagInput
        ref={ref}
        type="text"
        className={classnames(styles["input"], inputClassName)}
        tabIndex={restProps.disabled ? -1 : 0}
        {...restProps}
        onKeyDown={isPreventKeyDownForNumberTypeStrict ? (e) => {
          if (restProps?.onKeyDown) {
            restProps.onKeyDown(e);
          }

          preventKeyDownForNumberTypeStrict(e);
        } : restProps?.onKeyDown}
      />
      {slotAfter ? handleReactSlot(slotAfter) : null}
    </TagRoot>
  );
});

Input.defaultProps = {
  variant: InputVariant.default,
};

Input.variant = InputVariant;
Input.size = InputSize;

Input.propTypes = {
  rounded: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(InputVariant)),
  size: PropTypes.oneOf(Object.values(InputSize)),
  slotAfter: PropTypes.any,
  tagInput: PropTypes.any,
};

export default Input;
